import Marquee from "react-fast-marquee";
import { Asterisk } from "lucide-react";

const ITEMS = ["Service AC", "Kulkas", "Mesin Cuci", "Mesin Cuci Laundry", "Pengering Laundry", "Showcase Kaca"];

export default function ServicesMarquee() {
  return (
    <div data-testid="services-marquee" className="border-y border-ink/10 py-5 bg-void relative z-10">
      <Marquee speed={35} gradient={false} pauseOnHover>
        {ITEMS.map((item) => (
          <span key={item} className="inline-flex items-center gap-6 mx-6">
            <span className="font-display font-extrabold uppercase tracking-tight text-2xl md:text-3xl text-stroke hover:text-brand-ink transition-colors duration-300">
              {item}
            </span>
            <Asterisk size={22} className="text-brand-ink" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
